import { useMainStore } from '@/store/pinia';
import ArticleDetail from '@/views/contents/ArticleDetail.vue';
import ArticleManagement from '@/views/contents/ArticleManagement.vue';
import ExhibitionCrawlManagement from '@/views/contents/ExhibitionCrawlManagement.vue';
import BannerDetail from '@/views/contents/BannerDetail.vue';
import BannerManagement from '@/views/contents/BannerManagement.vue';
import MonthlyContentDetail from '@/views/contents/MonthlyContentDetail.vue';
import MonthlyContentManagement from '@/views/contents/MonthlyContentManagement.vue';
import SpecialDetail from '@/views/contents/SpecialDetail.vue';
import SpecialManagement from '@/views/contents/SpecialManagement.vue';
import Home from '@/views/Home.vue';
import CollaborationDetail from '@/views/support/CollaborationDetail.vue';
import CollaborationManagement from '@/views/support/CollaborationManagement.vue';
import InquiryDetail from '@/views/support/InquiryDetail.vue';
import InquiryManagement from '@/views/support/InquiryManagement.vue';
import NoticeDetail from '@/views/support/NoticeDetail.vue';
import NoticeManagement from '@/views/support/NoticeManagement.vue';
import MenuManagement from '@/views/system/MenuManagement.vue';
import UserDetailOld from '@/views/user/old/UserDetailOld.vue';
import UserManagementOld from '@/views/user/old/UserManagementOld.vue';
import UserApprovalDetail from '@/views/user/UserApprovalDetail.vue';
import UserApprovalList from '@/views/user/UserApprovalList.vue';
import UserDetail from '@/views/user/UserDetail.vue';
import UserList from '@/views/user/UserList.vue';
import { createRouter, createWebHistory } from 'vue-router';
import ViewCountAnalysis from '@/views/analytics/ViewCountAnalysis.vue';
import ViewLogAnalysis from '@/views/analytics/ViewLogAnalysis.vue';
import ArtistVisibilityManager from '@/views/contents/ArtistVisibilityManager.vue';
import ArtistArtworkSearch from '@/views/contents/ArtistArtworkSearch.vue';
import ContestDetail from '@/views/contest/ContestDetail.vue';
import ContestFileDownload from '@/views/contest/ContestFileDownload.vue';
import ContestManagement from '@/views/contest/ContestManagement.vue';
import ContestApplicants from '@/views/contest/ContestApplicants.vue';
import ServiceInfoDetail from '@/views/info/ServiceInfoDetail.vue';
import OrganizationAccountList from '@/views/organization/OrganizationAccountList.vue';
import OrganizationList from '@/views/organization/OrganizationList.vue';
import AdminList from '@/views/system/AdminList.vue';
import RoleList from '@/views/system/RoleList.vue';
import UserArtistArtWorkList from '@/views/user/UserArtistArtWorkList.vue';
import UserArtistList from '@/views/user/UserArtistList.vue';
import UserArtistProfileDetail from '@/views/user/UserArtistProfileDetail.vue';

const routes = [
  {
    path: '/',
    name: 'Home',
    component: Home,
  },
  {
    path: '/content/banner',
    name: 'Banner',
    component: BannerManagement,
  },
  {
    path: '/content/banner/:uuid',
    name: 'BannerDetail',
    component: BannerDetail,
    props: true
  },
  {
    path: '/content/banner/create',
    name: 'BannerCreate',
    component: BannerDetail,
    props: false,
  },
  // New monthly content routes (polymorphic)
  {
    path: '/content/monthly-contents',
    name: 'MonthlyContent',
    component: MonthlyContentManagement,
  },
  {
    path: '/content/monthly-contents/:id',
    name: 'MonthlyContentDetail',
    component: MonthlyContentDetail,
    props: true
  },
  {
    path: '/content/monthly-contents/create',
    name: 'MonthlyContentCreate',
    component: MonthlyContentDetail,
    props: false,
  },
  {
    path: '/content/monthly-artists',
    name: 'MonthlyArtist',
    component: MonthlyContentManagement,
  },
  {
    path: '/content/monthly-artists/:id',
    name: 'MonthlyArtistDetail',
    component: MonthlyContentDetail,
    props: true
  },
  {
    path: '/content/monthly-artists/create',
    name: 'MonthlyArtistCreate',
    component: MonthlyContentDetail,
    props: false,
  },
  {
    path: '/article/special',
    name: 'Special',
    component: SpecialManagement,
  },
  {
    path: '/content/article/special/:uuid?',
    name: 'SpecialDetail',
    component: SpecialDetail,
    props: true
  },
  {
    // /article/:articleType 이 catch-all 이라 /article/... 아래에 두지 않는다.
    // 다른 콘텐츠 화면(banner·contest·artist-search)과 같은 /content/ 계열로 맞춘다. (mimio#71)
    path: '/content/exhibition-crawl',
    name: 'ExhibitionCrawlManagement',
    component: ExhibitionCrawlManagement
  },
  {
    path: '/article/:articleType',
    name: 'Article',
    component: ArticleManagement,
    props: true
  },
  {
    path: '/content/article/:articleType/:uuid?',
    name: 'ArticleDetail',
    component: ArticleDetail,
    props: true
  },
  {
    path: '/content/artist',
    name: 'ArtistVisibilityManager',
    component: ArtistVisibilityManager,
  },
  {
    path: '/content/artist-search',
    name: 'ArtistArtworkSearch',
    component: ArtistArtworkSearch,
  },
  {
    path: '/user',
    name: 'UserList',
    component: UserList,
    props: true
  },
  {
    path: '/user/:userUuid',
    name: 'UserDetail',
    component: UserDetail,
    props: true
  },
  {
    path: '/user/artist',
    name: 'UserArtistList',
    component: UserArtistList,
    props: true
  },
  {
    path: '/user/:userAccountId/artist',
    name: 'UserArtistProfileDetail',
    component: UserArtistProfileDetail,
    props: true
  },
  {
    path: '/user/:userAccountId/artwork',
    name: 'UserArtistArtWorkList',
    component: UserArtistArtWorkList,
    props: true
  },
  {
    path: '/user/approval',
    name: 'UserApprovalList',
    component: UserApprovalList,
    props: true
  },
  {
    path: '/user/:userUuid/approval',
    name: 'UserApprovalDetail',
    component: UserApprovalDetail,
    props: true
  },
  {
    path: '/user/:userType',
    name: 'UserManagementOld',
    component: UserManagementOld,
    props: true
  },
  {
    path: '/user/:userType/:mode/:id?',
    name: 'UserDetailOld',
    component: UserDetailOld,
    props: true
  },
  {
    path: '/menu/:type',
    name: 'MenuManagement',
    component: MenuManagement,
    props: true
  },
  {
    path: '/support/notice',
    name: 'NoticeManagement',
    component: NoticeManagement,
  },
  {
    path: '/support/notice/create',
    name: 'NoticeWrite',
    component: NoticeDetail,
    props: false,
  },
  {
    path: '/support/notice/:uuid',
    name: 'NoticeDetail',
    component: NoticeDetail,
    props: true,
  },
  {
    path: '/support/inquiry',
    name: 'InquiryManagement',
    component: InquiryManagement,
  },
  {
    path: '/support/inquiry/:uuid',
    name: 'InquiryDetail',
    component: InquiryDetail,
    props: true,
  },
  {
    path: '/support/collaboration',
    name: 'CollaborationManagement',
    component: CollaborationManagement,
  },
  {
    path: '/support/collaboration/:uuid',
    name: 'CollaborationDetail',
    component: CollaborationDetail,
    props: true,
  },
  {
    path: '/info/service',
    name: 'ServiceInfoDetail',
    component: ServiceInfoDetail,
  },
  {
    path: '/content/contest',
    name: 'ContestManagement',
    component: ContestManagement,
  },
  {
    path: '/content/contest/create',
    name: 'ContestCreate',
    component: ContestDetail,
    props: true,
  },
  {
    // 지원자 관리 (mimio#80)
    path: '/content/contest/:uuid/applicants',
    name: 'ContestApplicants',
    component: ContestApplicants,
  },
  {
    path: '/content/contest/download',
    name: 'ContestFileDownload',
    component: ContestFileDownload,
  },
  {
    path: '/content/contest/:uuid',
    name: 'ContestDetail',
    component: ContestDetail,
    props: true,
  },
  {
    path: '/organization',
    name: 'OrganizationList',
    component: OrganizationList,
  },
  {
    path: '/organization/account',
    name: 'OrganizationAccountList',
    component: OrganizationAccountList,
  },
  {
    path: '/system/admin',
    name: 'AdminList',
    component: AdminList,
  },
  {
    path: '/system/role',
    name: 'RoleList',
    component: RoleList,
  },
  {
    path: '/analytics/view-logs',
    name: 'ViewLogAnalysis',
    component: ViewLogAnalysis,
  },
  {
    path: '/analytics/view-counts',
    name: 'ViewCountAnalysis',
    component: ViewCountAnalysis,
  },
  {
    path: '/analytics/dashboard',
    name: 'StatsDashboard',
    component: () => import('@/views/analytics/StatsDashboard.vue'),
  },
  {
    path: '/analytics/members',
    name: 'StatsMembers',
    component: () => import('@/views/analytics/StatsMembers.vue'),
  },
  {
    path: '/analytics/artists',
    name: 'StatsArtists',
    component: () => import('@/views/analytics/StatsArtists.vue'),
  },
  {
    path: '/analytics/content',
    name: 'StatsContent',
    component: () => import('@/views/analytics/StatsContent.vue'),
  },
  {
    path: '/analytics/traffic',
    name: 'StatsTraffic',
    component: () => import('@/views/analytics/StatsTraffic.vue'),
  },
  {
    // 개발용 — 메뉴 비노출. 통계 디자인 시스템 갤러리(컴포넌트/토큰 카탈로그)
    path: '/analytics/design-system',
    name: 'StatsDesignSystem',
    component: () => import('@/views/analytics/StatsDesignSystem.vue'),
  },

];

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes,
});

router.beforeEach((to, from, next) => {
  window.scrollTo(0, 0)
  const mainStore = useMainStore();
  localStorage.setItem('currentPath', mainStore.currentPath);
  next()
});

export default router;
